export enum ToolNames {
  search = 'search',
  layerSelection = 'layerSelection',
  identify = 'identify',
  draw = 'draw',
  print = 'print',
  save = 'save',
  share = 'share',
  help = 'help',
  undo = 'undo',
  reset = 'reset',
}
